export default Object.freeze({
    Primary : 'primary',
    Secondary :'secondary',
    Tertiary : 'tertiary',
    Destructive : 'destructive',
    Text: 'text',
    Round : 'round',
    SmallIcon : 'small-icon',
    UnitSwitcher : 'unit-switcher',
    SliderSelected : 'slider-selected',
    SliderNotSelected : 'slider-not-selected',
})
